import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Header from '../../Components/Header/Header';
import Sidebar from '../../Components/Sidebar/Sidebar';
import '../AdventureShared.css';

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const bookingId = searchParams.get('bookingId');
  const type = searchParams.get('type');
  const certificationId = searchParams.get('certificationId');
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          if (type === 'certification' && certificationId) {
            navigate(`/certifications/${certificationId}`);
          } else {
            navigate(`/facilitate/orders/${bookingId}`);
          }
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [bookingId, certificationId, type, navigate]);

  return (
    <div className="PaymentCallbackPage" style={{ color: '#ffffff', backgroundColor: '#071414', minHeight: '100vh' }}>
      <div className="adventurePageContainer">
        <div className="headerContain">
          <Header />
        </div>
        <div className="adventurePageContainer2">
          <div className="sidebarContain">
            <Sidebar />
          </div>
          <main className="adv-page-main" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '75vh' }}>
            <div 
              style={{
                background: 'rgba(14, 27, 27, 0.95)',
                border: '1.5px solid rgba(40, 167, 69, 0.25)',
                borderRadius: '16px',
                padding: '40px',
                width: '100%',
                maxWidth: '480px',
                textAlign: 'center',
                boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.4)',
                animation: 'adv-fade-in 0.3s ease forwards'
              }}
            >
              <div 
                style={{
                  fontSize: '48px',
                  width: '80px',
                  height: '80px',
                  lineHeight: '80px',
                  background: 'rgba(40, 167, 69, 0.12)',
                  color: '#28a745',
                  borderRadius: '50%',
                  margin: '0 auto 24px auto',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 'bold'
                }}
              >
                ✓
              </div>
              <h2 style={{ fontSize: '24px', fontWeight: '700', marginBottom: '12px', color: '#ffffff' }}>
                Payment Secured!
              </h2>
              <p style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '24px' }}>
                {type === 'certification' 
                  ? 'Your payment was processed successfully. You are now enrolled in the certification course.'
                  : 'Your payment was processed successfully. The funds are now securely held in escrow and your reservation has been finalized.'}
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '24px' }}>
                <button
                  onClick={() => {
                    if (type === 'certification' && certificationId) {
                      navigate(`/certifications/${certificationId}`);
                    } else {
                      navigate(`/facilitate/orders/${bookingId}`);
                    }
                  }}
                  style={{
                    background: '#3bb3ae',
                    color: '#071414',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '12px 24px',
                    fontSize: '15px',
                    fontWeight: '700',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                >
                  {type === 'certification' ? 'Go to Certification Details' : 'Go to Order Details'}
                </button>
                <span style={{ fontSize: '12px', color: 'rgba(255, 255, 255, 0.4)' }}>
                  Redirecting automatically in {countdown} seconds...
                </span>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
